import React, {useEffect} from 'react';
import {BrowserRouter, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import useAuthStore from './store/authStore';
import MainPage from './components/pages/MainPage';
import LoginPage from './components/pages/LoginPage';
import SignupPage from './components/pages/SignupPage';
import MeetingListPage from './components/pages/meeting/MeetingListPage';
import MeetingPage from './components/pages/meeting/MeetingPage';
import MeetingUpdatePage from './components/pages/meeting/MeetingUpdatePage';
import ExplorePage from './components/pages/meeting/ExplorePage';
import ChatListPage from './components/pages/chat/ChatListPage';
import ChatPage from './components/pages/chat/ChatPage';
import MyPage from './components/pages/my/MyPage';
import SettingPage from './components/pages/my/settings/SettingPage';
import ForcePhoneVerificationPage from './components/pages/ForcePhoneVerificationPage';
import PhoneReverificationPage from './components/pages/my/settings/PhoneReverificationPage';
import WelcomePage from './components/pages/WelcomePage';
import BannedPage from './components/pages/BannedPage';
import AccountInfoPage from './components/pages/my/settings/AccountInfoPage';
import PasswordChangePage from './components/pages/my/settings/PasswordChangePage';
import ProfileEditPage from './components/pages/my/ProfileEditPage';
import CreateMeetingPage from './components/pages/meeting/CreateMeetingPage';
import EventListPage from './components/pages/my/EventListPage';
import MeetingApplicationFormPage from './components/pages/meeting/MeetingApplicationFormPage';
import MyPendingMeetingApplicationListPage from './components/pages/my/MyPendingMeetingApplicationListPage';
import MeetingApplicationPage from './components/pages/meeting/MeetingApplicationPage';
import MeetingMeetingApplicationListPage from './components/pages/meeting/MeetingMeetingApplicationListPage';
import PlaceSelectionPage from './components/pages/meeting/PlaceSelectionPage';
import LocationSelectionPage from './components/pages/my/LocationSelectionPage';
import NotificationPage from "./components/pages/my/NotificationPage";
import HostedMeetingListPage from './components/pages/my/HostedMeetingListPage';
import JoinedMeetingListPage from './components/pages/my/JoinedMeetingListPage';
import SearchPage from './components/pages/meeting/SearchPage';
//import KakaoCallbackPage from './components/pages/KakaoCallbackPage';
//import KakaoSignupPage from './components/pages/KakaoSignupPage';
import PasswordResetPage from './components/pages/PasswordResetPage';
import ReportInMeetingPage from './components/pages/meeting/ReportInMeetingPage';
import ReportOutOfMeetingPage from './components/pages/meeting/ReportOutOfMeetingPage';
import AnnouncementListPage from './components/pages/my/AnnouncementListPage';
import AnnouncementPage from './components/pages/my/AnnouncementPage';
import EventPage from './components/pages/my/EventPage';
import PartnerPlaceFormPage from "./components/pages/my/PartnerPlaceFormPage";
import PartnerPlaceInfoPage from "./components/pages/my/PartnerPlaceInfoPage";
import CustomerCenterPage from "./components/pages/my/CustomerCenterPage";
import MobileNotFoundPage from "./components/pages/MobileNotFoundPage";
import RestaurantCertificatePage from './components/pages/chat/RestaurantCertificatePage';
import BlockManagementPage from './components/pages/my/settings/BlockManagementPage';
import RicePurchasePage from './components/pages/my/RicePurchasePage';
import RiceWalletPage from './components/pages/my/RiceWalletPage';
import TermsPage from './components/pages/my/TermsPage';
import PrivacyPage from './components/pages/my/PrivacyPage';
import FrequentQuestionPage from './components/pages/my/FrequentQuestionPage';

export const getRouteByStatus = (status) => {
    switch (status) {
        case 'ACTIVE':
            return '/app/meetings';
        case 'CREATED':
            return '/app/welcome';
        case 'PHONE_V_REQUIRED':
            return '/app/force-phone-verification';
        case 'BANNED':
            return '/app/banned';
        default:
            return '/app/meetings';
    }
};

const ProtectedRoute = ({ children, member }) => {
    const location = useLocation();
    if (!member) {
        return <Navigate to="/app" replace />;
    }
    if (member.status !== 'ACTIVE') {
        const redirectPath = getRouteByStatus(member.status);
        if (location.pathname !== redirectPath) {
            return <Navigate to={redirectPath} replace />;
        }
    }
    return children;
};

const StatusRoute = ({ children, member, allowedStatus }) => {
    const location = useLocation();
    if (!member) {
        return <Navigate to="/app" replace />;
    }
    if (member.status !== allowedStatus) {
        const redirectPath = getRouteByStatus(member.status);
        if (location.pathname !== redirectPath) {
            return <Navigate to={redirectPath} replace />;
        }
    }
    return children;
};

const MobileRoutes = () => {
    const { checkAuth, member, isLoading } = useAuthStore();

    useEffect(() => {
        // 앱이 시작될 때 한 번만 인증 상태를 확인합니다.
        checkAuth();
    }, [checkAuth]);

    // 로딩 상태에 따라 로딩 스피너를 표시합니다.
    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '24px' }}>
                로딩 중...
            </div>
        );
    }

    // 로딩이 끝난 후, 라우팅을 시작합니다.
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/app" element={
                    member ? <Navigate to={getRouteByStatus(member.status)} replace /> : <MainPage />
                } />
                <Route path="/app/login" element={
                    member ? <Navigate to={getRouteByStatus(member.status)} replace /> : <LoginPage />
                } />
                <Route path="/app/signup" element={
                    member ? <Navigate to={getRouteByStatus(member.status)} replace /> : <SignupPage />
                } />
                <Route path="/app/password-reset" element={
                    member ? <Navigate to={getRouteByStatus(member.status)} replace /> : <PasswordResetPage />
                } />

                {/*<Route path="/app/auth/kakao/callback" element={<KakaoCallbackPage />} />*/}
                {/*<Route path="/app/signup/kakao" element={<KakaoSignupPage />} />*/}

                <Route path="/app/welcome" element={
                    <StatusRoute member={member} allowedStatus="CREATED">
                        <WelcomePage />
                    </StatusRoute>
                } />
                <Route path="/app/force-phone-verification" element={
                    <StatusRoute member={member} allowedStatus="PHONE_V_REQUIRED">
                        <ForcePhoneVerificationPage />
                    </StatusRoute>
                } />
                <Route path="/app/banned" element={
                    <StatusRoute member={member} allowedStatus="BANNED">
                        <BannedPage />
                    </StatusRoute>
                } />

                <Route path="/app/meetings" element={
                    <ProtectedRoute member={member}>
                        <MeetingListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/meetings/:meetingId" element={
                    <ProtectedRoute member={member}>
                        <MeetingPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/meetings/:meetingId/update" element={
                    <ProtectedRoute member={member}>
                        <MeetingUpdatePage />
                    </ProtectedRoute>
                } />
                <Route path="/app/meetings/:meetingId/application" element={
                    <ProtectedRoute member={member}>
                        <MeetingApplicationFormPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/meetings/:meetingId/applications" element={
                    <ProtectedRoute member={member}>
                        <MeetingMeetingApplicationListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/meetings/:meetingId/report/out-of-meeting" element={
                    <ProtectedRoute member={member}>
                        <ReportOutOfMeetingPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/explore" element={
                    <ProtectedRoute member={member}>
                        <ExplorePage />
                    </ProtectedRoute>
                } />
                <Route path="/app/chat" element={
                    <ProtectedRoute member={member}>
                        <ChatListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/chat/:meetingId" element={
                    <ProtectedRoute member={member}>
                        <ChatPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/chat/:meetingId/report/in-meeting" element={
                    <ProtectedRoute member={member}>
                        <ReportInMeetingPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage" element={
                    <ProtectedRoute member={member}>
                        <MyPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/settings" element={
                    <ProtectedRoute member={member}>
                        <SettingPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/settings/account-info" element={
                    <ProtectedRoute member={member}>
                        <AccountInfoPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/settings/change-password" element={
                    <ProtectedRoute member={member}>
                        <PasswordChangePage />
                    </ProtectedRoute>
                } />
                <Route path="/app/settings/phone-reverification" element={
                    <ProtectedRoute member={member}>
                        <PhoneReverificationPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/settings/profile-edit" element={
                    <ProtectedRoute member={member}>
                        <ProfileEditPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/settings/block-management" element={
                    <ProtectedRoute member={member}>
                        <BlockManagementPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/create-meeting" element={
                    <ProtectedRoute member={member}>
                        <CreateMeetingPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/place-selection" element={
                    <ProtectedRoute member={member}>
                        <PlaceSelectionPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/location-selection" element={
                    <ProtectedRoute member={member}>
                        <LocationSelectionPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/notification" element={
                    <ProtectedRoute member={member}>
                        <NotificationPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/events" element={
                    <ProtectedRoute member={member}>
                        <EventListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/events/:eventId" element={
                    <ProtectedRoute member={member}>
                        <EventPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/pending-meeting-applications" element={
                    <ProtectedRoute member={member}>
                        <MyPendingMeetingApplicationListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/meeting-applications/:meetingApplicationId" element={
                    <ProtectedRoute member={member}>
                        <MeetingApplicationPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/hosted-meetings" element={
                    <ProtectedRoute member={member}>
                        <HostedMeetingListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/joined-meetings" element={
                    <ProtectedRoute member={member}>
                        <JoinedMeetingListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/location-selection" element={
                    <ProtectedRoute member={member}>
                        <LocationSelectionPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/announcements" element={
                    <ProtectedRoute member={member}>
                        <AnnouncementListPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/announcements/:announcementId" element={
                    <ProtectedRoute member={member}>
                        <AnnouncementPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/partner-place/form" element={
                    <ProtectedRoute member={member}>
                        <PartnerPlaceFormPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/partner-place/my" element={
                    <ProtectedRoute member={member}>
                        <PartnerPlaceInfoPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/rice-wallet" element={
                    <ProtectedRoute member={member}>
                        <RiceWalletPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/rice-purchase" element={
                    <ProtectedRoute member={member}>
                        <RicePurchasePage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/frequent-questions" element={
                    <ProtectedRoute member={member}>
                        <FrequentQuestionPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/terms" element={
                    <ProtectedRoute member={member}>
                        <TermsPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/mypage/privacy" element={
                    <ProtectedRoute member={member}>
                        <PrivacyPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/customer-center" element={
                    <ProtectedRoute member={member}>
                        <CustomerCenterPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/search" element={
                    <ProtectedRoute member={member}>
                        <SearchPage />
                    </ProtectedRoute>
                } />
                <Route path="/app/chat/:meetingId/restaurant-certificate" element={
                    <ProtectedRoute member={member}>
                        <RestaurantCertificatePage />
                    </ProtectedRoute>
                } />
                <Route path="*" element={<MobileNotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default MobileRoutes;
